import angular from 'angular'
import modal from 'ui-bootstrap4/src/modal'

import { EmploymentProcessingDashboardComponent } from './employment-processing-dashboard/employment-processing-dashboard.component';
import { EmploymentTimelineReportDownloadModalComponent } from './employment-processing-dashboard/employment-timeline-report-download-modal.component';
import { AdpNumberAssignmentComponent } from './adp-number-assignment.component';
import { ProcessTerminationsComponent } from './process-terminations.component';
import { NewHiresProcessor } from './new-hires-processor.service';
import { TerminationsProcessor } from './terminations-processor.service';
import { EmployeeChangeHistoryProcessor } from './employee-change-history-processor.service';
import { ProcessChangeHistoryComponent } from './process-change-history.component';
import { ProcessDirectDepositComponent } from './process-direct-deposit.component';
import { DirectDepositProcessor } from './direct-deposit-processor.service';

export const EmploymentProcessingModule = angular
    .module("apex.mainApp.employmentProcessing", [
        modal
    ])
    .component("apexEmploymentProcessingDashboard", EmploymentProcessingDashboardComponent)
    .component("apexEmploymentTimelineReportDownloadModal", EmploymentTimelineReportDownloadModalComponent)
    .component("apexAdpNumberAssignment", AdpNumberAssignmentComponent)
    .component("apexProcessTerminations", ProcessTerminationsComponent)
    .component("apexProcessChangeHistory", ProcessChangeHistoryComponent)
    .component("apexProcessDirectDeposit", ProcessDirectDepositComponent)
    .service("newHiresProcessor", NewHiresProcessor)
    .service("terminationsProcessor", TerminationsProcessor)
    .service("directDepositProcessor", DirectDepositProcessor)
    .service("employeeChangeHistoryProcessor", EmployeeChangeHistoryProcessor)
    .name
